/**
 * Ubezpieczenia — teksty obszaru `claims` (kolejka Do kwalifikacji, szkody) pod `ins.claims.*`. WŁAŚCICIEL: obszar `claims`.
 * Podpięte już w i18n/insurance.ts. Słowniki (pl + en, razem ponad 400 linii) leżą przy funkcji:
 * `features/insurance/claims/i18n/claims-pl.ts` i `claims-en.ts` — tam dopisuj klucze. `en` typowane względem `pl`.
 */
import { claimsEn } from '@/features/insurance/claims/i18n/claims-en';
import { claimsPl, type Shape } from '@/features/insurance/claims/i18n/claims-pl';

export const insClaimsPl = claimsPl;

export const insClaimsEn: Shape<typeof insClaimsPl> = claimsEn;
